import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import si from './locales/si.json';
import ta from './locales/ta.json';

export const STORAGE_KEY = 'glowos_lang';
export const SUPPORTED_LANGUAGES = ['en', 'si', 'ta'];

const stored = localStorage.getItem(STORAGE_KEY);
const lng = SUPPORTED_LANGUAGES.includes(stored) ? stored : 'en';

const applyDocumentLanguage = (language) => {
  document.documentElement.lang = language;
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    si: { translation: si },
    ta: { translation: ta },
  },
  lng,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (language) => {
  localStorage.setItem(STORAGE_KEY, language);
  applyDocumentLanguage(language);
});

applyDocumentLanguage(lng);

export default i18n;
